export const HOME_URL = "https://simplify.yourstone.ie/api/pages/home";
export const GALLERY_URL = "https://simplify.yourstone.ie/api/gallery";
